import React from 'react';
import "./ToolSwitch.css"

const ToolSwitch = ({ value = 'normal', onChange }) => {
  const isLight = value === 'normal';
  const set = (v) => v !== value && onChange && onChange(v);

  return (
    <div
      className="tool-switch"
      role="radiogroup"
      aria-label="Ferramenta ativa"
    >
      <button
        type="button"
        role="radio"
        aria-checked={isLight}
        className={`tool-switch__item ${isLight ? 'is-active' : ''}`}
        onClick={() => set('normal')}
        title="Modo: Pontos de Luz"
      >
        <span className="tool-switch__dot tool-switch__dot--light" aria-hidden />
        <span className="tool-switch__label">Luz</span>
      </button>

      <button
        type="button"
        role="radio"
        aria-checked={!isLight}
        className={`tool-switch__item ${!isLight ? 'is-active' : ''}`}
        onClick={() => set('ledStrip')}
        title="Modo: Fitas LED"
      >
        <span className="tool-switch__dot tool-switch__dot--led" aria-hidden />
        <span className="tool-switch__label">LED</span>
      </button>
    </div>
  );
};

export default ToolSwitch;